<!-- Messages toggle -->
<button
    mat-icon-button
    (click)="openPanel()"
    [matTooltip]="'Downloads'"
    #messagesOrigin>
    <ng-container *ngIf="unreadCount > 0">
        <span class="absolute top-0 right-0 left-0 flex items-center justify-center h-3">
            <span class="flex items-center justify-center shrink-0 min-w-4 h-4 px-1 ml-4 mt-2.5 rounded-full bg-teal-600 text-indigo-50 text-xs font-medium">
                {{unreadCount}}
            </span>
        </span>
    </ng-container>
    <mat-icon class="text-gray-700" [svgIcon]="'custom:arrow-down-tray'"></mat-icon>
</button>

<!-- Messages panel -->
<ng-template #messagesPanel>

    <div class="fixed inset-0 sm:static sm:inset-auto flex flex-col sm:min-w-90 sm:w-90 sm:rounded-2xl overflow-hidden shadow-lg">

        <!-- Header -->
        <div class="flex shrink-0 items-center py-4 pr-4 pl-6 bg-primary text-on-primary">
            <div class="sm:hidden -ml-1 mr-3">
                <button
                    mat-icon-button
                    (click)="closePanel()">
                    <mat-icon
                        class="icon-size-5 text-current"
                        [svgIcon]="'custom:arrow-down-tray'"></mat-icon>
                </button>
            </div>
            <div class="text-lg font-medium leading-10">Downloads</div>
        </div>

        <!-- Content -->
        <div class="relative flex flex-col flex-auto sm:max-h-120 divide-y overflow-y-auto bg-card">
            <!-- Downloads -->
            <ng-container *ngFor="let download of availableDownloads; trackBy: trackByFn">
                <div [disabled]="true"
                    class="flex group hover:bg-gray-50 dark:hover:bg-black dark:hover:bg-opacity-5">

                    <ng-container>
                        <div class="flex flex-auto py-5 pl-6">
                            <ng-container *ngTemplateOutlet="downloadContent"></ng-container>
                        </div>
                    </ng-container>

                    <div class="relative flex flex-col my-5 mr-6 ml-2" >
                        <button (click)="onDownloadFileClicked(download.file_url)" [disabled]="!download.is_download_ready">
                            <mat-icon class="text-gray-700" [svgIcon]="'custom:arrow-down-tray'"></mat-icon>
                        </button>
                    </div>
                    <div class="relative flex flex-col my-5 mr-6 ml-2" >
                        <button (click)="deleteDownloadRecord(download.id)" >
                            <mat-icon class="text-gray-700" [svgIcon]="'custom:delete-forever'"></mat-icon>
                        </button>
                    </div>
                    
                </div>

                <!-- Download content template -->
                <ng-template #downloadContent >
                    <!-- Title & time -->
                    <div class="flex flex-col flex-auto">
                        <ng-container *ngIf="download.title">
                            <div
                                class="font-semibold line-clamp-1"
                                [innerHTML]="download.title"></div>
                        </ng-container>
                        <div class="mt-2 text-sm leading-none text-secondary">
                            {{ download.created_on | date:'MMM dd, hh:mm a':'UTC'- offset}}
                        </div>
                    <div>
                    <mat-progress-bar class="mt-2 text-sm leading-none text-secondary"
                    *ngIf="!download.is_download_ready" mode="indeterminate"></mat-progress-bar>
                        
                       </div>
                    </div>
                </ng-template>
            </ng-container>

            <!-- No messages -->
            <ng-container *ngIf="!availableDownloads || !availableDownloads.length">
                <div class="flex flex-col flex-auto items-center justify-center sm:justify-start py-12 px-8">
                    <div class="flex flex-0 items-center justify-center w-14 h-14 rounded-full bg-primary-100">
                        <mat-icon
                            class="text-primary-500-700"
                            [svgIcon]="'heroicons_outline:inbox'"></mat-icon>
                    </div>
                    <div class="mt-5 text-2xl font-semibold tracking-tight">No downloads</div>
                    <div class="w-full max-w-60 mt-1 text-md text-center text-secondary">When you have downloads, they will appear here.</div>
                </div>
            </ng-container>
        </div>
    </div>
</ng-template>
